// TODO remove @material-ui
import { Box, Button, Grid, Typography } from "@material-ui/core";
import DropImage from "../../assets/images/dropzone_illustration.svg";
import { Card } from "@cti-workspace/ui";

const DefaultView = () => (
	<Card style={{ padding: "16px", borderRadius: "16px", justifyContent: "center", alignItems: "center" }}>
		<Grid container component={Box} height="100%" style={{ borderStyle: "dashed" }} border={2} borderRadius={16} borderColor="#0099CC" direction="column" spacing={3} justifyContent="center" alignItems="center">
			<Grid item component={Box} width="30%">
				<img src={DropImage} with={"100%"} />
				<Typography align="center" color="secondary">
					{/* <FormattedMessage id="verify.route.newDefaultView.subtitle" /> */}
				</Typography>
				<Typography align="center" variant={"subtitle1"}>
					{/* <FormattedMessage id="verify.route.defaultView.caption" /> */}
				</Typography>
			</Grid>
			<Grid component={Box} item width="100%">
				<Grid container component={Box} width="100%">
					<Grid item xs={3} />
					<Grid item xs={2}>
						<hr />
					</Grid>
					<Grid item xs={2} component={Box}>
						<Typography align="center">or</Typography>
					</Grid>
					<Grid item xs={2}>
						<hr />
					</Grid>
					<Grid item xs={3} />
				</Grid>
			</Grid>
			<Grid item container alignItems="center" direction="column">
				<Button variant="outlined" color="secondary">
					Select File
				</Button>
				<Typography variant="subtitle2" style={{ marginTop: "2rem" }}>
					(Upload .xslx file for bulk verification)
				</Typography>
			</Grid>
		</Grid>
	</Card>
);

export default DefaultView;
